/* font constants for styled components */
const fontFamily = {
  Aspira: 'Aspira',
  AspiraBold: 'Aspira-Bold',
  AspiraMedium: 'Aspira-Medium',
  AspiraRegular: 'Aspira-Regular'
};

export default fontFamily;
